"use client";

import { getCookie, setCookie, deleteCookie } from "cookies-next/client";

const GUEST_ID_COOKIE = "guest_id";

export function getGuestId(): string {
  let guestId = getCookie(GUEST_ID_COOKIE);

  if (!guestId || typeof guestId !== "string") {
    guestId = crypto.randomUUID();

    setCookie(GUEST_ID_COOKIE, guestId, {
      maxAge: 60 * 60 * 24 * 365, // 1 year
      sameSite: "lax",
      secure: process.env.NODE_ENV === "production",
      path: "/",
    });
  }

  return guestId;
}

export function clearGuestId() {
  deleteCookie(GUEST_ID_COOKIE, {
    path: "/",
  });
}
